import { usePageTitle } from './usePageTitle'

export default usePageTitle
